import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import fblogo from "../../../assets/Images/About/fblogoblack.svg";
import linkdln from "../../../assets/Images/About/linkdlnblack.svg";
import insta from "../../../assets/Images/About/instablack.svg";
import youtube from "../../../assets/Images/About/youtubeblack.svg";
import Distributeyourfilms from "./Distributeyourfilms";
import OACForm from "./OACForm";
import PlaylistForm from "./PlaylistForm";
import MarketingForm from "./MarketingForm";

// Define the sections with their content
const sections = [
    { id: 0, title: "Distribute your films", content: <Distributeyourfilms /> },
    { id: 1, title: "OAC (Official Artist Channel)", content: <OACForm /> },
    { id: 2, title: "Playlist form", content: <PlaylistForm /> },
    { id: 3, title: "Marketing Form", content: <MarketingForm /> },
];

const LegalFormsSecondSection = ({ selectedPlanId }) => {
    // Initialize with selectedPlanId or default to section 0
    const [currentSection, setCurrentSection] = useState(
        selectedPlanId !== null && selectedPlanId >= 0 && selectedPlanId < sections.length
            ? selectedPlanId
            : 0
    );

    useEffect(() => {
        // Update section when selectedPlanId changes
        if (selectedPlanId !== null && selectedPlanId >= 0 && selectedPlanId < sections.length) {
            setCurrentSection(selectedPlanId);
        }
    }, [selectedPlanId]);

    const handleNext = () => {
        if (currentSection < sections.length - 1) {
            setCurrentSection(currentSection + 1);
        }
    };

    const handlePrevious = () => {
        if (currentSection > 0) {
            setCurrentSection(currentSection - 1);
        }
    };

    return (
        <Box className="legal-documents-section">
            <Box className="content-section">
                <Box className="side-menu">
                    <Typography variant="h6" className="menu-title">
                        Legal Documents
                    </Typography>
                    {sections.map((sec, i) => (
                        <Typography
                            key={sec.id}
                            className={`menu-item ${currentSection === i ? "active" : ""}`}
                            onClick={() => setCurrentSection(i)}
                        >
                            {sec.title}
                            {currentSection === i && <div className="active-line"></div>}
                        </Typography>
                    ))}
                </Box>

                <Box className="content">
                    <Typography variant="h4" className="content-title">
                        {sections[currentSection].title}
                    </Typography>
                    <Typography className="content-text">
                        {sections[currentSection].content}
                    </Typography>

                    <Box className="navigation-buttons">
                        <Button
                            className="nav-button"
                            onClick={handlePrevious}
                            disabled={currentSection === 0}
                        >
                            Previous Page
                        </Button>
                        <Button
                            className="nav-button"
                            onClick={handleNext}
                            disabled={currentSection === sections.length - 1}
                        >
                            Next Page
                        </Button>
                    </Box>

                    <Box className="contact-us">
                        <Typography variant="h5" className="contact-title">
                            Contact Us
                        </Typography>
                        <Typography className="contact-text">
                            Got questions or need support? Reach out via:
                        </Typography>
                        <Box className="contact-info">
                            <Typography>Email: info@fmdigitalofficial.com</Typography>
                            <Typography>Website: www.fmdigitalofficial.com</Typography>
                        </Box>
                        <Box className="social-links">
                            <a href="https://in.linkedin.com/company/fmdigitalofficial" target="_blank" rel="noopener noreferrer">
                                <img src={linkdln} alt="LinkedIn Logo" />
                            </a>
                            <a href="https://www.instagram.com/fmdigitalofficial/" target="_blank" rel="noopener noreferrer">
                                <img src={insta} alt="Instagram Logo" />
                            </a>
                            {/* <a href="https://www.facebook.com/FMDigital2/" target="_blank" rel="noopener noreferrer">
                                <img src={fblogo} alt="Facebook Logo" />
                            </a> */}
                            <a href="https://www.youtube.com/@fm_digital" target="_blank" rel="noopener noreferrer">
                                <img src={youtube} alt="YouTube Logo" />
                            </a>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default LegalFormsSecondSection;
